// extracted by mini-css-extract-plugin
module.exports = {"fiftyFiftyRow":"FormWidgets_fiftyFiftyRow__1JwEd","left":"FormWidgets_left___v4b9","right":"FormWidgets_right__fjQx_"};